import { useEffect, useRef, RefObject } from 'react'

import { animateExpand, setExpandState } from './complianceAnimations'

/** Ref for a collapsible region — animates open/closed via GSAP (height +
 *  dissolve) whenever `open` changes, in both directions. The first render
 *  snaps to the initial state instead of animating, so a group that starts
 *  open doesn't visibly tween in on page load. The element this ref is
 *  attached to must stay mounted across toggles — gate what's inside it on
 *  other conditions if needed, but keep the wrapper itself unconditional. */
export const useExpandCollapse = (open: boolean): RefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null)
  const isFirstRender = useRef(true)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (isFirstRender.current) {
      isFirstRender.current = false
      setExpandState(el, open)
      return
    }
    animateExpand(el, open)
  }, [open])

  return ref
}
